export const GET_USER_GROUPS = 'GET_USER_GROUPS';
export const USER_GROUPS_UPDATED = 'USER_GROUPS_UPDATED';